<div style="min-height: 550px">
  <nb-card>
    <nb-card-header>
      <h3 style="position: relative" i18n>QA Tool</h3>
    </nb-card-header>
    <nb-card-body>
      <div>
        <app-common-bots></app-common-bots>
      </div>
    </nb-card-body>
  </nb-card>
</div>
